module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "vw-number"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.subtract
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number",
      "max": _vm.max,
      "min": _vm.min,
      "step": _vm.steps
    },
    domProps: {
      "value": _vm.val
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("+")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-742b615e!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/number.vue
// module id = 264
// module chunks = 0